document.addEventListener('keydown', event => {
  if (event.key === 'Escape') document.querySelectorAll('.mobile-navigation[open]').forEach(menu => { menu.open = false; menu.querySelector('summary').focus(); });
});
document.addEventListener('click', event => {
  if (event.target.closest('.mobile-navigation a')) document.querySelector('.mobile-navigation').open = false;
  const link = event.target.closest('[data-site-event]');
  if (!link || link.disabled) return;
  // Shared consent-aware analytics adapter; no arbitrary link or customer data.
  window.ShipzikEvents?.emit(link.dataset.siteEvent, link.dataset.product || null);
});

// Credits open on request; Escape returns focus to the info control.
document.querySelectorAll('.map-credits, .how-visual-note').forEach(credits => {
  credits.addEventListener('keydown', event => {
    if (event.key === 'Escape') {
      credits.open = false;
      credits.querySelector('summary').focus();
    }
  });
});

// Native details retain keyboard behavior; this also supports older browsers
// without exclusive details groups and opens existing feature deep links.
const featurePanels = [...document.querySelectorAll('.capability[name="product-features"]')];
function openFeaturePanel(panel) {
  featurePanels.forEach(other => { if (other !== panel) other.open = false; });
  panel.open = true;
}
featurePanels.forEach(panel => panel.addEventListener('toggle', () => {
  if (panel.open) featurePanels.forEach(other => { if (other !== panel) other.open = false; });
}));
function revealFeatureHash() {
  const panel = featurePanels.find(item => '#' + item.id === location.hash);
  if (!panel) return;
  openFeaturePanel(panel);
  // Closing an earlier panel changes the target’s position.
  requestAnimationFrame(() => panel.scrollIntoView({ block: 'start', behavior: 'instant' }));
}
if (featurePanels.length) {
  revealFeatureHash();
  window.addEventListener('hashchange', revealFeatureHash);
}

// Pack links remain real product URLs. Enhance only these two destinations,
// retaining the surrounding page, focus, scroll position, and open disclosures.
const productPage = document.querySelector('[data-product-page]');
if (productPage) {
  window.ShipzikEvents?.emit('product_viewed', productPage.dataset.pack);
  const options = [...productPage.querySelectorAll('[data-pack-option]')];
  const purchase = productPage.querySelector('[data-product-purchase]');
  const status = productPage.querySelector('.product-update-status');
  const metadata = 'title, meta[name="description"], link[rel="canonical"], meta[property^="og:"], meta[name^="twitter:"], script[data-product-schema]';
  const cache = new Map();
  let requestVersion = 0;
  let pendingControls = [];
  const routeKey = href => {
    const url = new URL(href, location.href);
    return url.origin + url.pathname + '?view=' + (url.searchParams.get('view') || '');
  };
  const extractProduct = doc => {
    const page = doc.querySelector('[data-product-page]');
    if (!page?.querySelector('[data-product-purchase]') || !page.querySelector('.product-gallery') || !page.querySelector('.product-price')) throw new Error('Missing product');
    return {
      pack: page.dataset.pack,
      gallery: page.querySelector('.product-gallery').cloneNode(true),
      price: page.querySelector('.product-price').innerHTML,
      purchase: page.querySelector('[data-product-purchase]').innerHTML,
      metadata: [...doc.querySelectorAll(metadata)].map(node => node.cloneNode(true))
    };
  };
  cache.set(routeKey(location.href), { time: Date.now(), promise: Promise.resolve(extractProduct(document)) });
  const loadProduct = option => {
    const key = routeKey(option.href);
    const cached = cache.get(key);
    if (cached && Date.now() - cached.time < 60000) return cached.promise;
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 10000);
    const promise = fetch(option.href, { signal: controller.signal, headers: { Accept: 'text/html' } })
      .then(response => {
        if (!response.ok) throw new Error('Product unavailable');
        return response.text();
      })
      .then(html => {
        const product = extractProduct(new DOMParser().parseFromString(html, 'text/html'));
        if (product.pack !== option.dataset.packOption) throw new Error('Unexpected product');
        return product;
      })
      .catch(error => { cache.delete(key); throw error; })
      .finally(() => clearTimeout(timeout));
    cache.set(key, { time: Date.now(), promise });
    return promise;
  };
  const finishSwitch = () => {
    productPage.removeAttribute('aria-busy');
    options.forEach(option => option.classList.remove('is-loading'));
    pendingControls.forEach(control => { control.disabled = false; });
    pendingControls = [];
  };
  async function switchPack(option, addHistory) {
    const version = ++requestVersion;
    finishSwitch();
    if (option.dataset.packOption === productPage.dataset.pack) { status.textContent = ''; return; }
    productPage.setAttribute('aria-busy', 'true');
    option.classList.add('is-loading');
    status.textContent = 'Updating your selection…';
    pendingControls = [...purchase.querySelectorAll('button:not(:disabled), input:not(:disabled)')];
    pendingControls.forEach(control => { control.disabled = true; });
    try {
      const product = await loadProduct(option);
      if (version !== requestVersion) return;
      const quantity = purchase.querySelector('[name="quantity"]')?.value;
      const gallery = productPage.querySelector('.product-gallery');
      const scene = gallery.querySelector('.label-scene');
      const nextScene = product.gallery.querySelector('.label-scene');
      if (scene && nextScene) {
        // Keep the illustration in the DOM so the stack can smoothly fan out.
        scene.classList.toggle('is-pack', product.pack === 'pack');
        scene.setAttribute('aria-label', nextScene.getAttribute('aria-label'));
      } else {
        gallery.replaceChildren(...product.gallery.cloneNode(true).childNodes);
      }
      productPage.querySelector('.product-price').innerHTML = product.price;
      purchase.innerHTML = product.purchase;
      const quantityInput = purchase.querySelector('[name="quantity"]');
      if (quantityInput && quantity) quantityInput.value = quantity;
      productPage.dataset.pack = product.pack;
      options.forEach(link => {
        const selected = link === option;
        link.classList.toggle('selected', selected);
        if (selected) link.setAttribute('aria-current', 'page');
        else link.removeAttribute('aria-current');
      });
      document.querySelectorAll(metadata).forEach(node => node.remove());
      product.metadata.forEach(node => document.head.append(node.cloneNode(true)));
      if (addHistory) history.pushState(history.state, '', option.href);
      window.ShipzikEvents?.emit('pack_selected', product.pack);
      window.ShipzikEvents?.emit('product_viewed', product.pack);
      status.textContent = `${option.textContent.trim().replace(/\s+/g, ' ')} selected.`;
    } catch {
      // Normal navigation is still available if the enhancement cannot load.
      if (version === requestVersion) location.assign(option.href);
    } finally {
      if (version === requestVersion) finishSwitch();
    }
  }
  options.forEach(option => {
    const preload = () => { if (option.dataset.packOption !== productPage.dataset.pack) loadProduct(option).catch(() => {}); };
    option.addEventListener('pointerenter', preload);
    option.addEventListener('focus', preload);
    option.addEventListener('click', event => {
      if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || new URL(option.href).origin !== location.origin) return;
      event.preventDefault();
      switchPack(option, true);
    });
  });
  window.addEventListener('popstate', () => {
    const option = options.find(link => routeKey(link.href) === routeKey(location.href));
    if (option) switchPack(option, false);
    else location.reload();
  });
  // Fetch the alternate once after initial rendering, so a first tap is ready.
  if (!navigator.connection?.saveData) {
    const preload = () => options.filter(link => link.dataset.packOption !== productPage.dataset.pack).forEach(link => loadProduct(link).catch(() => {}));
    if ('requestIdleCallback' in window) requestIdleCallback(preload, { timeout: 1500 });
    else setTimeout(preload, 500);
  }
}

// Shopify remains the source of truth for prices, discounts, and quantities.
const cartPage = document.querySelector('[data-cart-page]');
if (cartPage) {
  cartPage.classList.add('is-enhanced');
  let cartBusy = false;
  const feedback = cartPage.querySelector('[data-cart-feedback]');
  const showCartFeedback = message => {
    feedback.textContent = message;
  };
  const updateCartBadge = count => {
    const link = document.querySelector('.bag-link');
    if (!link) return;
    link.setAttribute('aria-label', `Bag, ${count} ${count === 1 ? 'item' : 'items'}`);
    let badge = link.querySelector('span');
    if (count > 0) {
      if (!badge) { badge = document.createElement('span'); link.append(badge); }
      badge.textContent = count;
    } else badge?.remove();
  };
  async function changeCartItem(row, quantity, focusName) {
    if (cartBusy) return;
    const input = row.querySelector('[data-cart-quantity]');
    if (!Number.isInteger(quantity) || quantity < 0 || quantity > Number(input.max)) {
      input.reportValidity();
      return;
    }
    if (quantity === Number(input.dataset.original)) return;
    cartBusy = true;
    cartPage.setAttribute('aria-busy', 'true');
    cartPage.querySelectorAll('.cart-item-error').forEach(message => message.remove());
    showCartFeedback('Updating your bag…');
    const index = Number(row.dataset.index);
    const name = row.dataset.name;
    const controls = [...cartPage.querySelectorAll('button:not(:disabled), input:not(:disabled)')];
    controls.forEach(control => { control.disabled = true; });
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 15000);
    try {
      const response = await fetch(cartPage.dataset.changeUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: row.dataset.key, quantity, sections: [cartPage.dataset.sectionId], sections_url: cartPage.dataset.cartUrl }),
        signal: controller.signal
      });
      const cart = await response.json();
      if (!response.ok) throw new Error(typeof cart.description === 'string' ? cart.description : 'Your bag could not be updated. Please try again.');
      const html = cart.sections?.[cartPage.dataset.sectionId];
      const updated = html && new DOMParser().parseFromString(html, 'text/html').querySelector('#CartContent');
      // A failed section render can follow a successful cart update. Never repeat the mutation.
      if (!updated) { window.location.reload(); return; }
      cartPage.querySelector('#CartContent').replaceWith(updated);
      updateCartBadge(cart.item_count);
      showCartFeedback(quantity === 0 ? `${name} removed.` : 'Your bag is updated.');
      const rows = [...cartPage.querySelectorAll('[data-cart-item]')];
      const nextRow = rows[Math.min(index, rows.length - 1)];
      const focusTarget = quantity === 0 ? nextRow?.querySelector('[data-cart-quantity]') : nextRow?.querySelector(`[data-focus="${focusName}"]:not(:disabled)`);
      (focusTarget || nextRow?.querySelector('[data-cart-quantity]') || cartPage.querySelector('#cart-title')).focus({ preventScroll: true });
    } catch (error) {
      input.value = input.dataset.original;
      // Keep checkout unavailable after an uncertain response until an update or refresh succeeds.
      const checkout = cartPage.querySelector('[name="checkout"]');
      if (checkout && controls.includes(checkout)) controls.splice(controls.indexOf(checkout), 1);
      const message = error.name === 'AbortError' || error instanceof TypeError || error instanceof SyntaxError ? 'We could not confirm your update. Refresh your bag before checking out.' : error.message;
      const errorText = document.createElement('p');
      errorText.className = 'cart-item-error';
      errorText.textContent = message;
      row.append(errorText);
      showCartFeedback(message);
    } finally {
      clearTimeout(timeout);
      controls.forEach(control => { control.disabled = false; });
      cartBusy = false;
      cartPage.removeAttribute('aria-busy');
    }
  }
  cartPage.addEventListener('click', event => {
    const step = event.target.closest('[data-quantity-step]');
    const remove = event.target.closest('[data-cart-remove]');
    if (!step && !remove) return;
    event.preventDefault();
    if (cartBusy) return;
    const row = (step || remove).closest('[data-cart-item]');
    const input = row.querySelector('[data-cart-quantity]');
    const quantity = remove ? 0 : Number(input.dataset.original) + Number(step.dataset.quantityStep);
    changeCartItem(row, quantity, (step || remove).dataset.focus);
  });
  cartPage.addEventListener('change', event => {
    if (event.target.matches('[data-cart-quantity]') && event.target.reportValidity()) {
      changeCartItem(event.target.closest('[data-cart-item]'), event.target.valueAsNumber, 'quantity');
    }
  });
  cartPage.addEventListener('keydown', event => {
    if (event.key === 'Enter' && event.target.matches('[data-cart-quantity]')) {
      event.preventDefault();
      if (event.target.reportValidity()) changeCartItem(event.target.closest('[data-cart-item]'), event.target.valueAsNumber, 'quantity');
    }
  });
  cartPage.addEventListener('submit', event => { if (cartBusy) event.preventDefault(); });
}
